export enum sendTimeType {
    now = 'now',
    time = 'time',
}

export enum broadcastStatus {
    planned = 1,
    inProgress = 2,
    finished = 3,
    cancelled = 4,
    starting = 5,
}

export const broadcastStatusNames = {
    [broadcastStatus.planned]: 'Запланирована',
    [broadcastStatus.inProgress]: 'В процессе',
    [broadcastStatus.finished]: 'Закончена',
    [broadcastStatus.cancelled]: 'Отменена',
    [broadcastStatus.starting]: 'Стартует',
};

export enum broadcastSegmentation {
    list = 'list',
    visitors = 'visitors',
}

export const broadcastSegmentationNames = {
    [broadcastSegmentation.list]: 'Свой список',
    [broadcastSegmentation.visitors]: 'База бота',
};

export enum sendBroadcastsType {
    text = 1,
    promo = 2,
}

export const statusList = [
    {
        label: 'Запланирована',
        key: 'Запланирована',
        text: 'Запланирована',
        value: 1,
    },
    {
        label: 'В процессе',
        key: 'В процессе',
        text: 'В процессе',
        value: 2,
    },
    {
        label: 'Закончена',
        key: 'Закончена',
        text: 'Закончена',
        value: 3,
    },
    {
        label: 'Отменена',
        key: 'Отменена',
        text: 'Отменена',
        value: 4,
    },
    {
        label: 'Начинается',
        key: 'Начинается',
        text: 'Начинается',
        value: 5,
    },
];
